/* eslint-disable react/react-in-jsx-scope */
import Calques from "@/assets/icones/calques.svg?react";
import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";

const MapLayerSelector = ({
  baseLayers,
  map,
}: {
  baseLayers: Record<string, L.TileLayer>;
  map: L.Map | null;
}) => {
  const [selectedLayer, setSelectedLayer] = useState<string>(
    Object.keys(baseLayers)[0]
  );

  const handleLayerSelect = (key: string) => {
    const newLayer = baseLayers[key];
    if (!newLayer || !map) return;

    // Retirer toutes les couches de base
    Object.values(baseLayers).forEach((layer) => {
      if (map.hasLayer(layer)) {
        map.removeLayer(layer);
      }
    });

    // Ajouter la nouvelle couche sélectionnée
    newLayer.addTo(map);
    setSelectedLayer(key);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-2 bg-white py-2 px-4 rounded-full h-[34px]">
          <Calques />
          Calques
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" side="top">
        <div>
          <p className="text-[.95rem] mb-2 text-muted-foreground px-3 ">
            Affichage de la carte de base
          </p>
          {Object.keys(baseLayers).map((key) => {
            const isSatellite = key.toLowerCase().includes("satellite");
            const isSelected = selectedLayer === key;

            return (
              <div
                key={key}
                onClick={() => handleLayerSelect(key)}
                className={`flex items-center justify-between py-2 px-3 rounded cursor-pointer hover:bg-muted transition-colors `}
              >
                <div className="flex flex-col">
                  <p className="font-semibold m-0">
                    {isSatellite ? "Satellite" : "Standard"}
                  </p>
                  <span className="text-sm text-muted-foreground">
                    {isSatellite
                      ? "Image photoréaliste de la Terre."
                      : "Carte de base abstraite, sans relief"}
                  </span>
                </div>
                <div>
                  <Input
                    type="radio"
                    name="carte"
                    value={key}
                    checked={isSelected}
                    readOnly
                  />
                </div>
              </div>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default MapLayerSelector;
